import UtilFormat from 'utils/UtilFormat';
import { getStringAsCurrency } from 'utils/currency';

const appendCurrencySymbolByLocale = (amount, currencySymbol) => {
    if (!currencySymbol) return amount;
    return isLocaleSpecialFormat() ? `${currencySymbol} ${amount}` : `${amount} ${currencySymbol}`;
};

export const formatNumberWithSeparator = (number) => {
    let parts;
    let formatedNumber;
    if (isLocaleSpecialFormat()) {
        parts = number.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        formatedNumber = parts.join('.');
    } else {
        parts = number.toString().split(',');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        formatedNumber = parts.join(',');
    }
    return formatedNumber;
};

// Returns true for locales with decimal comma and currency symbol at left
const isLocaleSpecialFormat = () =>
    getLocaleDecimalFormat() === 'en-US' ||
    getLocaleDecimalFormat() === 'en-GB' ||
    getLocaleDecimalFormat() === 'th-TH';

const getLocaleDecimalFormat = () => UtilFormat._localeDecimalFormat;

// TODO deprecated? use the currency util to get the string
export const formatLargeAmount = (number, currencySymbol, decimals = 2) =>
    appendCurrencySymbolByLocale(formatLargeNumber(number, decimals), currencySymbol);

export const formatLargeNumber = (number, decimals = 2) => {
    if (isNaN(number)) return number;
    number = parseFloat(number);

    const locale = UtilFormat._localeDecimalFormat || 'es-ES';

    if (Math.abs(number) < 1000) {
        return new Intl.NumberFormat(locale, {
            maximumFractionDigits: decimals,
        }).format(number);
    }

    return new Intl.NumberFormat(locale, {
        notation: 'compact',
        compactDisplay: 'short',
        maximumFractionDigits: decimals,
    }).format(number);
};

export const formatLargeAmountCurrency = (number, useCurrency, currency, decimals = 2) => {
    let finalValue = formatLargeNumber(number, decimals);
    if (useCurrency) {
        finalValue = getStringAsCurrency(finalValue, currency);
    }
    return finalValue;
};

export const getPercentage = (total, partial) => {
    let percentage = total !== 0 && partial !== 0 ? ((partial * 100) / total).toFixed(0) : 0;
    return percentage;
};
